export default {
  path: "/admin",
  name: "organization",
  component: () => import("@/views/organization-admin/LayoutView.vue"),
  children: [
    {
      path: "",
      redirect: "my",
    },
    {
      path: "my",
      props: {
        getDataUrl: "/my",
      },
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
    {
      path: "mtb",
      props: {
        getDataUrl: "/mtb",
      },
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
    {
      path: ":dir(groupe)/view/:id",
      component: () => import("@/views/organization/group-gov/GroupGovView.vue"),
    },
    {
      path: ":dir(class)/view/:id(all)",
      component: () => import("@/components/default/view/DefaultView.vue"),
    },

    {
      path: ":dir(class)/view/:id",
      name: "placeView",
      component: () => import("@/views/gos-organization/place/PlaceView.vue"),
    },

    {
      path: ":parentDir(class)/:placeId/:dir(subject)/view/:id",
      name: "placeView",
      component: () => import("@/views/gos-organization/class-gov/GroupGovView.vue"),
    },
    {
      path: ":dir(gos-journal)/view/:id",
      component: () => import("@/views/organization-admin/journal/JournalView.vue"),
    },
    {
      path: ":dir(gos-journal)/view/:id",
      component: () => import("@/views/organization-admin/journal/JournalView.vue"),
    },

    {
      path: ":dir(place)/:subdir(submited)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=1",
      },
    },
    {
      path: ":dir(place)/:subdir(approved)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=2",
      },
    },
    {
      path: ":dir(place)/:subdir(rejected)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=3",
      },
    },
    {
      path: ":dir(place)/:subdir(revoked)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=4",
      },
    },
    {
      path: ":dir(journal)/view/:id",
      component: () => import("@/views/organization-admin/journal/JournalView.vue"),
    },
    // {
    //   path: ":dir(remark)/(list)*",
    //   component: () => import("@/views/organization-admin/journal/JournalList.vue"),
    // },
    {
      path: ":dir(staff)/(list)*",
      component: () => import("@/views/organization/staff/StaffList.vue"),
    },
    {
      path: ":dir/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
    },
    {
      path: ":dir/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
    }
  ],
};
